import request from "@/config/axios";

/**
 * HomePostUserInfo
 * 基本信息(临时用，后续对接登录之后改成从登陆获取)
 * @param Object {accontId, accountType, studentId}
 * @return Object {accountName, accountType, unitName, userPhoto}
 */
 export function HomePostUserInfo(data) {
  return request({
    url: "/portal/settings/getUserInfo",
    method: "GET",
    mode: "service",
    params: data,
  });
}

/**
 * getUserManger
 * 3.7.17.根据当前用户获取用户平台管理权限（教育局管理|学校管理）
 * @param userId
 */
 export function HomeGetUserManger(userId) {
  return request({
    url: "portal/settings/getUserManger?userId=" + userId,
    method: "get",
    mode: "service",
  });
}

//学校、老师、学生统计数
export function schoolPage(data) {
    return request({
      url: "/release/base-data/schools/page",
      method: "GET",
      mode: "service",
      params:data,
    });
  }

  // 按学段统计学校数
  export function schoolByStep(data) {
      return request({
        url: "/release/base-data/statistic/schools/byStep",
        method: "GET",
        mode: "service",
        params:data,
      });
    }

    // 按学段统计学生数
    export function studentByStep(data) {
        return request({
          url: "/release/base-data/statistic/students/byStep",
          method: "GET",
          mode: "service",
          params:data,
        });
      }

      // 免登学校、老师、学生统计数
    export function statistic(data) {
        return request({
          url: "/release/base-data/statistic",
          method: "GET",
          mode: "service",
          params:data,
        });
      }

      // 免登老师、学生统计数
    export function statisticBySchool(data) {
        return request({
          url: "/release/base-data/statistic/school",
          method: "GET",
          mode: "service",
          params:data,
        });
      }

      // 新的统计日志总数
    export function getCount(data) {
        return request({
          url: "/release/url-access/getCount",
          method: "GET",
          mode: "log",
          params:data,
        });
      }

       // 统计日志总数
    export function count(data) {
        return request({
          url: "/release/url-access/count",
          method: "GET",
          mode: "log",
          params:data,
        });
      }

      // 插入日志
    export function insert(data) {
        return request({
          url: "/release/url-access/insert",
          method: "POST",
          mode: "log",
          data,
        });
      }

      // 按学段统计
      export function statisticByStep(data) {
          return request({
            url: "/release/base-data/statistic/byStep",
            method: "GET",
            mode: "service",
            params:data,
          });
        }

      // 获取首页初始数据
      export function indexData(data) {
          return request({
            url: "/release/index/indexDataByColumn",
            method: "GET",
            mode: "service",
            params:data,
          });
        }
        // 菜单
      export function indexColumn(data) {
          return request({
            url: "/release/index/indexColumn",
            method: "GET",
            mode: "service",
            params:data,
          });
        }

      // 分页查询栏目内容
      export function pageContent(data) {
          return request({
            url: "/release/index/pageContent",
            method: "GET",
            mode: "service",
            params:data,
          });
        }

      // 栏目内容详情
      export function detail(data) {
          return request({
            url: "/release/index/content/detail",
            method: "GET",
            mode: "service",
            params:data,
          });
        }

         // 三个课堂名师工作室
      export function queryStatisticsStudio(data) {
          return request({
            url: "/open/studio/queryStatisticsStudio",
            method: "post",
            mode: "resource",
            data,
          });
        }

        export function queryStudioDynamicNnl(data) {
            return request({
              url: "/open/studio/statistics/queryStudioDynamicNnl",
              method: "post",
              mode: "resource",
              data,
            });
          }